const createWallet = ({ passkey, addressProvider, publicKeyProvider, backedUpAtom, analyticsUserIdAtom, shareActivityAtom, credentialIdAtom, }) => {
    let locked = true;
    let unlockPromise = null;
    const unlock = async ({ forceReconnect = false } = {}) => {
        const unlocking = unlockPromise !== null;
        if (unlocking && !forceReconnect) {
            return unlockPromise;
        }
        unlockPromise = new Promise(async (resolve) => {
            try {
                const { credentialId, addresses, publicKeys, backedUp, telemetryId, shareActivity, } = await passkey.connect();
                if (!credentialId) {
                    throw new Error(`Couldn't connect to wallet`);
                }
                analyticsUserIdAtom?.set(telemetryId);
                shareActivityAtom?.set(shareActivity);
                await Promise.all([
                    backedUpAtom.set(backedUp),
                    publicKeyProvider.load(publicKeys),
                    addressProvider.load(addresses),
                ]);
                locked = false;
                resolve(credentialId);
            }
            catch {
                resolve(null);
            }
            finally {
                unlockPromise = null;
            }
        });
        return unlockPromise;
    };
    const exists = async () => true;
    const isLocked = async () => locked;
    const lock = async () => {
        locked = true;
    };
    const clear = async () => {
        await lock();
    };
    // These are currently unsupported
    const setBackedUp = () => { };
    const getExtraSeedIds = () => [];
    const getPrimarySeedId = () => credentialIdAtom.get();
    return {
        exists,
        isLocked,
        lock,
        unlock,
        clear,
        setBackedUp,
        getExtraSeedIds,
        getPrimarySeedId,
    };
};
const walletDefinition = {
    id: 'wallet',
    type: 'module',
    factory: createWallet,
    public: true,
    dependencies: [
        'passkey',
        'addressProvider',
        'publicKeyProvider',
        'backedUpAtom',
        'shareActivityAtom?',
        'analyticsUserIdAtom?',
        'credentialIdAtom',
    ],
};
export default walletDefinition;
